import React, { useState } from 'react';
import { Gift } from 'lucide-react';
import { ReferralModal } from '../referral/ReferralModal';

export const ReferralTrigger: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="fixed bottom-6 right-6 z-40 bg-white border-2 border-maple-200 shadow-lg text-maple-600 rounded-full px-5 py-3 flex items-center gap-2 hover:shadow-xl hover:scale-105 hover:border-maple-300 transition-all group"
        aria-label="Share and give feedback"
      >
        <Gift size={22} className="group-hover:animate-bounce" />
        <span className="font-semibold text-sm">Share & Feedback</span>
      </button>

      <ReferralModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};
